import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PageMeta } from './PageMeta'
import { ProductListItemDto } from './ProductListItemDto'
/**
* Class ProductListItemPage
*  
*/
export class ProductListItemPage extends ActiveModel {

  /**
  * meta
  * Meta-информация о результате постраничного запроса  */
  @ActiveField({
    factory: [PageMeta, () => undefined]
  })
  meta?: PageMeta


/**
  * @property items
  * Список элементов страницы<br>  */
  @ActiveField({
    factory: [ProductListItemDto, () => undefined]
  })
  items?: Array<ProductListItemDto>


  /**
  * attributesMeta
  * Метаданные атрибутов<br>  */
  @ActiveField(() => undefined)
  attributesMeta?: Record<string, object>
}
